document.addEventListener('DOMContentLoaded', function() {
    // Flexible resources block api call
    const newsRow = document.getElementById("news-row");
    if (!newsRow) return;
    
    // Handle card hover effects
    function handleCardMouseEnter(card) {
        card.querySelector(".link-btm").style.color = "#1565c0";
        card.querySelector(".link-btm").style.textDecoration = "underline";
        card.querySelector(".right-arrow").style.filter = "invert(27%) sepia(98%) saturate(1361%) hue-rotate(195deg) brightness(90%) contrast(92%)";
        card.querySelector('.caption').classList.add("slide-up");
        card.querySelector('.caption').classList.remove("slide-down");
    }
    
    function handleCardMouseLeave(card) {
        card.querySelector(".link-btm").style.color = "#804180";
        card.querySelector(".link-btm").style.textDecoration = "none";
        card.querySelector(".right-arrow").style.filter = "none";
        card.querySelector('.caption').classList.add("slide-down");
    }
    
    // Use event delegation for better performance
    newsRow.addEventListener('mouseenter', function(event) {
        const card = event.target.closest('.card');
        if (card) handleCardMouseEnter(card);
    }, true);
    
    newsRow.addEventListener('mouseleave', function(event) {
        const card = event.target.closest('.card');
        if (card) handleCardMouseLeave(card);
    }, true);
});